import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/inter';
import '@fontsource-variable/bricolage-grotesque';
import './styles/tokens.css';
import './index.css';
import App from './App';
import { DialogsProvider } from './components/Dialogs';
import { LanguageProvider } from './i18n/I18n';
// After the app's own stylesheets, so the shared components win over them
import './styles/components.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <DialogsProvider>
        <App />
      </DialogsProvider>
    </LanguageProvider>
  </React.StrictMode>
);
